import { isPriceEqual } from "@@/shared/prices/price";
import { svTranslator } from "@@/shared/translations/translation";
import type { OrderItem_V2 } from "./order-item-v2";

const isOrderItemEqual = (
    orderItem: OrderItem_V2,
    orderItem2: OrderItem_V2,
) => {
    switch (orderItem.acquireType) {
        case "BOOKABLE":
            if (orderItem2.acquireType !== "BOOKABLE") return false;

            return (
                orderItem.productId === orderItem2.productId &&
                orderItem.time._id === orderItem2.time._id &&
                isPriceEqual(orderItem.price, orderItem2.price) &&
                orderItem.messageToProvider === orderItem2.messageToProvider
            );
        case "BUYABLE":
            if (orderItem2.acquireType !== "BUYABLE") return false;
            return (
                orderItem.productId === orderItem2.productId &&
                orderItem2.quantity.value === orderItem.quantity.value &&
                isPriceEqual(orderItem.price, orderItem2.price) &&
                orderItem.extraGroup?._id === orderItem2.extraGroup?._id &&
                orderItem.messageToProvider === orderItem2.messageToProvider
            );

        case "VOUCHER":
            if (orderItem2.acquireType !== "VOUCHER") return false;
            return (
                orderItem.productId === orderItem2.productId &&
                orderItem2.quantity.value === orderItem.quantity.value &&
                isPriceEqual(orderItem.price, orderItem2.price) &&
                orderItem.messageToProvider === orderItem2.messageToProvider
            );
        case "GIFTCARD":
            if (orderItem2.acquireType !== "GIFTCARD") return false;
            return (
                orderItem.productId === orderItem2.productId &&
                orderItem2.quantity.value === orderItem.quantity.value &&
                isPriceEqual(orderItem.price, orderItem2.price) &&
                orderItem.messageToProvider === orderItem2.messageToProvider
            );
        case "OPTIONAL":
            if (orderItem2.acquireType !== "OPTIONAL") return false;
            return (
                orderItem.optional._id === orderItem2.optional._id &&
                orderItem2.quantity.value === orderItem.quantity.value &&
                isPriceEqual(orderItem.price, orderItem2.price)
            );
        case "RESOURCE_REFERENCE":
            if (orderItem2.acquireType !== "RESOURCE_REFERENCE") return false;
            return (
                orderItem.reference === orderItem2.reference &&
                orderItem2.quantity.value === orderItem.quantity.value &&
                // orderItem.time._id === orderItem2.time._id &&
                isPriceEqual(orderItem.price, orderItem2.price) &&
                svTranslator(orderItem.meta.title) ===
                    svTranslator(orderItem2.meta.title)
            );
        case "GIFTCARD_USED":
            if (orderItem2.acquireType !== "GIFTCARD_USED") return false;
            return (
                orderItem.code === orderItem2.code &&
                orderItem.ticketId === orderItem2.ticketId &&
                orderItem2.quantity.value === orderItem.quantity.value &&
                isPriceEqual(orderItem.price, orderItem2.price)
            );

        case "DISCOUNT":
            if (orderItem2.acquireType !== "DISCOUNT") return false;
            return (
                orderItem.code === orderItem2.code &&
                orderItem.discountCodeId === orderItem2.discountCodeId &&
                orderItem2.quantity.value === orderItem.quantity.value &&
                isPriceEqual(orderItem.price, orderItem2.price)
            );
        case "ACCOMMODATION": {
            if (orderItem2.acquireType !== "ACCOMMODATION") return false;

            const quantityList = orderItem.quantities;
            const quantityList2 = orderItem2.quantities;

            if (quantityList.length !== quantityList2.length) return false;

            for (let i = 0; i < quantityList.length; i++) {
                if (
                    quantityList[i].quantity.value !==
                        quantityList2[i].quantity.value ||
                    quantityList[i].type._id !== quantityList2[i].type._id
                ) {
                    return false;
                }
            }

            return (
                orderItem.productId === orderItem2.productId &&
                orderItem.time._id === orderItem2.time._id &&
                orderItem.accommodation.rateId ===
                    orderItem2.accommodation.rateId &&
                orderItem.accommodation.resourceId ===
                    orderItem2.accommodation.resourceId &&
                orderItem.accommodation.type.typeId ===
                    orderItem2.accommodation.type.typeId &&
                orderItem.accommodation.type.subType?.typeId ===
                    orderItem.accommodation.type.subType?.typeId
            );
        }
        case "ACCOMMODATION_RATE_ITEM":
            if (orderItem2.acquireType !== "ACCOMMODATION_RATE_ITEM")
                return false;

            return (
                orderItem.rateId === orderItem2.rateId &&
                orderItem.time._id === orderItem2.time._id &&
                isPriceEqual(orderItem.price, orderItem2.price) &&
                ((orderItem.originalPrice === undefined &&
                    orderItem2.originalPrice === undefined) ||
                    isPriceEqual(
                        orderItem.originalPrice,
                        orderItem2.originalPrice,
                    ))
            );

        case "GENERIC_DISCOUNT":
            return false;
        case "GENERIC":
            return false;
        case "QUOTE_HEAD":
            return false;
    }
};
export { isOrderItemEqual };
